import React from "react";
import { Button, Icon, Toast } from "antd-mobile";
import { post } from "../../utils/request";
import { href, encode } from "../../utils/util";
import PapersUploadGR from "../modules/papersUpload_GR";
import AttestationType from "../modules/attestationType";
import AttestationStatus from "../modules/attestationStatus";
import AgreementText from "../modules/agreementText";
import DigitalText from "../modules/digitalText";

import api from "./api";
import Cookies from "js-cookie";
import wx from "wx";
import { SSQUrl } from "../../utils/config";

import "./index.less";

class ACPersonalPapers extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            iconType: false,
            phoneNumber: "", //手机号
            identifyCode: "", //验证码
            caType: "MOBILE", //认证方式： MOBILE（手机号验证），PERSONAL（刷脸认证）
            cerificationNo: "", //身份证号码
            customerName: "", //客户姓名
            front: "", //身份证正面
            back: "", //身份证反面
            status: "", // 是否认证成功状态
            agreementTextStatus: false, //协议文案展示状态
            digitalTextStatus: false, //协议文案展示状态
            urlOps: "",
            personalIdentity3Key: "",
            plateformType: "EQB",
        };
    }

    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }
            this.setState(
                {
                    urlOps: ops,
                },
                () => {
                    if (ops.plateformType) {
                        this.setState({
                            plateformType: ops.plateformType,
                        });
                    } else {
                        this.getPlateformType();
                    }
                }
            );
        }
    }

    // 查询默认认证平台类型
    getPlateformType = () => {
        const { urlOps } = this.state;
        let url =
            "/gateway/manageBedrock/bdDictionarycs/selectBdDictionary" +
            "?app_stoken=" +
            urlOps.app_stoken;
        post({
            url,
            data: {
                dictionaryCode: "SIGN_PLATEFORM_TYPE",
            },
        }).then(
            (res) => {
                this.setState({
                    plateformType: res.data.dictionaryValue,
                });
            },
            (res) => {
                console.log("查询查询默认认证平台类型失败", res);
                if (res.code == "-1") {
                    Toast.info("登录失效", 1);
                } else {
                    Toast.info("查询查询默认认证平台类型失败", 1);
                }
            }
        );
    };

    submit = () => {
        let {
            iconType,
            caType,
            phoneNumber,
            identifyCode,
            cerificationNo,
            customerName,
            front,
            back,
            personalIdentity3Key,
            plateformType,
        } = this.state;
        let _this = this;
        // if(!iconType){
        //     Toast.info('同意《远程慧联如何保护您的信息》后才可提交',1);
        //     return;
        // }
        if (caType !== "PERSONAL") {
            this.setState(
                {
                    status: "loading",
                },
                () => {
                    let url = "";
                    if (localStorage.getItem("app_stoken")) {
                        url =
                            api.h5.personalCertificate +
                            "?app_stoken=" +
                            localStorage.getItem("app_stoken");
                    } else if (localStorage.getItem("sessionKey")) {
                        url =
                            api.wechat.personalCertificate +
                            "?sessionKey=" +
                            localStorage.getItem("sessionKey");
                    } else {
                        url =
                            api.h5.personalCertificate +
                            "?session_key=" +
                            Cookies.get("session_key");
                    }
                    let ops = {
                        caType: "MOBILE",
                        customerName: customerName,
                        identity: cerificationNo,
                        phoneNumber: phoneNumber,
                        //   identifyCode: identifyCode,
                        identityImage: {
                            front: front,
                            back: back,
                        },
                        personalIdentity3Key,
                    };

                    if (plateformType === "SSQ") {
                        ops.identifyCode = identifyCode;
                    }

                    post({
                        url: url,
                        headers: {
                            "Content-Type": "application/json",
                        },
                        data: {
                            ...ops,
                            plateformType,
                        },
                    }).then(
                        (res) => {
                            console.log("手机认证", res);
                            if (res.result === "success") {
                                // this.setState({
                                //     status: 'success'
                                // });
                                if (plateformType === "EQB") {
                                    window.location.href = res.data.eqb.url;
                                } else {
                                    href("/ACFaceCa");
                                }
                            } else {
                                this.setState({
                                    status: "error",
                                });

                                if (res.code == "-1") {
                                    href("/ACLogin");
                                    Toast.info("登录失效", 1);
                                } else {
                                    Toast.info(res.msg);
                                }
                            }
                        },
                        (res) => {
                            console.log("手机认证失败", res);
                            this.setState({
                                status: "error",
                            });
                            if (res.code == "-1") {
                                href("/ACLogin");
                                Toast.info("登录失效", 1);
                            } else {
                                Toast.info("手机认证失败", 1);
                            }
                        }
                    );
                }
            );
        } else {
            let url = "",
                mobileNumber,
                returnUrl;
            if (localStorage.getItem("app_stoken")) {
                url =
                    api.h5.getPersonalFaceCaUrl +
                    "?app_stoken=" +
                    localStorage.getItem("app_stoken");
                mobileNumber = this.state.urlOps.mobileNumber;
                returnUrl =
                    window.location.origin +
                    window.location.pathname +
                    "#/ACFaceCa?url=" +
                    encode(
                        window.location.href +
                            "&app_stoken=" +
                            localStorage.getItem("app_stoken")
                    );
            } else if (localStorage.getItem("sessionKey")) {
                url =
                    api.wechat.getPersonalFaceCaUrl +
                    "?sessionKey=" +
                    localStorage.getItem("sessionKey");
                mobileNumber = this.state.urlOps.mobileNumber;
                returnUrl =
                    window.location.origin +
                    window.location.pathname +
                    "#/ACFaceCa?url=" +
                    encode(
                        window.location.href +
                            "&sessionKey=" +
                            localStorage.getItem("sessionKey")
                    );
            } else {
                url =
                    api.h5.getPersonalFaceCaUrl +
                    "?session_key=" +
                    Cookies.get("session_key");
                mobileNumber = this.state.urlOps.mobileNumber;
                returnUrl =
                    window.location.origin +
                    window.location.pathname +
                    "#/ACFaceCa?url=" +
                    encode(
                        window.location.href +
                            "&session_key=" +
                            Cookies.get("session_key")
                    );
            }
            post({
                url: url,
                headers: {
                    "Content-Type": "application/json",
                },
                data: {
                    from: localStorage.getItem("sessionKey") ? "MINI" : "H5",
                    userType: 1,
                    mobileNumber: mobileNumber,
                    name: customerName,
                    identity: cerificationNo,
                    returnUrl: returnUrl,
                    callbackHost: SSQUrl,
                    idCardFront: front,
                    idCardBack: back,
                    plateformType,
                },
            }).then(
                (res) => {
                    console.log("刷脸认证", res);
                    if (res.result === "success") {
                        if (localStorage.getItem("sessionKey")) {
                            wx.miniProgram.redirectTo({
                                url:
                                    "../face-webview/face-webview?url=" +
                                    encodeURIComponent(res.data),
                            });
                        } else {
                            window.location.href = res.data;
                        }
                    } else {
                        if (res.code == "-1") {
                            href("/ACLogin");
                            Toast.info("登录失效", 1);
                        } else {
                            Toast.info("刷脸认证失败", 1);
                        }
                    }
                },
                (res) => {
                    console.log("刷脸认证失败", res);

                    if (res.code == "-1") {
                        href("/ACLogin");
                        Toast.info("登录失效", 1);
                    } else {
                        Toast.info("刷脸认证失败", 1);
                    }
                }
            );
        }
    };

    submitTypeStatus = () => {
        const {
            iconType,
            phoneNumber,
            identifyCode,
            caType,
            cerificationNo,
            customerName,
            front,
            back,
            //   status,
            //   agreementTextStatus,
            //   digitalTextStatus,
            plateformType,
        } = this.state;
        if (plateformType === "EQB") {
            return (
                (caType === "MOBILE" &&
                    phoneNumber &&
                    //   identifyCode &&
                    cerificationNo &&
                    customerName &&
                    front &&
                    back &&
                    iconType) ||
                (caType === "PERSONAL" &&
                    cerificationNo &&
                    customerName &&
                    front &&
                    back &&
                    iconType)
            );
        } else {
            return (
                (caType === "MOBILE" &&
                    phoneNumber &&
                    identifyCode &&
                    cerificationNo &&
                    customerName &&
                    front &&
                    back &&
                    iconType) ||
                (caType === "PERSONAL" &&
                    cerificationNo &&
                    customerName &&
                    front &&
                    back &&
                    iconType)
            );
        }
    };

    render() {
        let {
            iconType,
            //   phoneNumber,
            //   identifyCode,
            caType,
            cerificationNo,
            customerName,
            //   front,
            //   back,
            status,
            agreementTextStatus,
            digitalTextStatus,
            plateformType,
        } = this.state;
        return (
            <div className="ACPersonalPapersBox">
                <div className="blockBox">
                    <h3>个人证件</h3>
                    <PapersUploadGR
                        name={customerName}
                        cerificationNo={cerificationNo}
                        onCancel={(
                            cerificationNo,
                            customerName,
                            front,
                            back
                        ) => {
                            this.setState({
                                cerificationNo,
                                customerName,
                                front,
                                back,
                            });
                        }}
                    />
                </div>
                <div className="blockBox">
                    <h3>请选择认证方式</h3>
                    <AttestationType
                        fangShi={this.state.caType}
                        source={"GR"}
                        cerificationNo={cerificationNo}
                        customerName={customerName}
                        plateformType={plateformType}
                        onCancel={(
                            phoneNumber,
                            identifyCode,
                            caType,
                            personalIdentity3Key
                        ) => {
                            this.setState({
                                phoneNumber,
                                identifyCode,
                                caType,
                                personalIdentity3Key,
                            });
                        }}
                    />
                </div>
                <div className="agreeBox">
                    <label
                        onClick={() => {
                            this.setState({
                                iconType: !iconType,
                            });
                        }}
                    >
                        {iconType ? <Icon type="check" /> : <Icon />}
                        <div>
                            我同意远程慧联对我提交的个人身份信息的保护办法
                            <a
                                onClick={() => {
                                    this.setState({
                                        agreementTextStatus: true,
                                    });
                                }}
                            >
                                《远程慧联如何保护您的信息》
                            </a>
                            <a
                                onClick={() => {
                                    this.setState({
                                        digitalTextStatus: true,
                                    });
                                }}
                            >
                                《数字证书使用协议》
                            </a>
                        </div>
                    </label>
                </div>
                <div className="queryBtnBox">
                    {this.submitTypeStatus() ? (
                        <Button
                            type="primary"
                            onClick={this.submit}
                        >
                            确认提交
                        </Button>
                    ) : (
                        <Button
                            type="primary"
                            disabled
                        >
                            确认提交
                        </Button>
                    )}
                    <div style={{ padding: "10px" }}>
                        个人身份信息将用于申请数字证书
                    </div>
                </div>
                <AttestationStatus
                    status={status}
                    caType={caType}
                    onRestart={() => {
                        this.submit();
                    }}
                    onQuit={(status) => {
                        this.setState({
                            status,
                        });
                    }}
                />
                {agreementTextStatus ? (
                    <AgreementText
                        agreementTextStatus={agreementTextStatus}
                        onQuit={(agreementTextStatus) => {
                            this.setState({
                                agreementTextStatus,
                            });
                        }}
                    />
                ) : (
                    ""
                )}
                {digitalTextStatus ? (
                    <DigitalText
                        digitalTextStatus={digitalTextStatus}
                        onQuit={(digitalTextStatus) => {
                            this.setState({
                                digitalTextStatus,
                            });
                        }}
                    />
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default ACPersonalPapers;



// WEBPACK FOOTER //
// ./src/authCertificate/ACPersonalPapers/index.js